$(function () {
	$('.js-faq-item').click(function () {
		$(this).toggleClass('faq__item-heading_active').next().slideToggle();
	});
})